import React from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import classNames from "classnames";

import { selectSetting } from "@features/global/globalSlice";

import { useAppSelector } from "@hooks/reduxHooks";

import { TEAM_LOGO_URL } from "@lib/globals";

import { useIndexContext } from "@Clubhouse/components/Index/contexts/Index";
import useTableHandlers from "@Clubhouse/components/Index/hooks/useTableHandlers";

const ClubhouseTable = (): React.JSX.Element => {
    const { handleHeaderClick } = useTableHandlers();
    const currentYear = useAppSelector(state =>
        selectSetting(state, "majorybl_current_league_year"),
    )?.setting;
    const { sortColumn, sortOrder, teams } = useIndexContext();

    return (
        <Table
            data-testid="clubhouseTable"
            className="clubhouseTable"
            striped
            bordered
            responsive
        >
            <thead>
                <tr>
                    <th data-sortable="false">Logo</th>
                    <th
                        onClick={() => handleHeaderClick("team")}
                        className={classNames({
                            sorting_asc:
                                sortColumn === "team" &&
                                sortOrder === "ascending",
                            sorting_desc:
                                sortColumn === "team" &&
                                sortOrder === "descending",
                        })}
                    >
                        Team
                    </th>
                    <th
                        onClick={() => handleHeaderClick("age")}
                        className={classNames({
                            sorting_asc:
                                sortColumn === "age" &&
                                sortOrder === "ascending",
                            sorting_desc:
                                sortColumn === "age" &&
                                sortOrder === "descending",
                        })}
                    >
                        Age Level
                    </th>
                    <th
                        onClick={() => handleHeaderClick("firstName")}
                        className={classNames({
                            sorting_asc:
                                sortColumn === "firstName" &&
                                sortOrder === "ascending",
                            sorting_desc:
                                sortColumn === "firstName" &&
                                sortOrder === "descending",
                        })}
                    >
                        First Name
                    </th>
                    <th
                        onClick={() => handleHeaderClick("lastName")}
                        className={classNames({
                            sorting_asc:
                                sortColumn === "lastName" &&
                                sortOrder === "ascending",
                            sorting_desc:
                                sortColumn === "lastName" &&
                                sortOrder === "descending",
                        })}
                    >
                        Last Name
                    </th>
                    <th data-sortable="false">Phone</th>
                    <th data-sortable="false">Email</th>
                </tr>
            </thead>
            <tbody>
                {teams.map(t => {
                    const currentTeamsLeague = t?.leagues?.find(
                        l => l.year === currentYear,
                    );

                    return (
                        <tr key={`${currentTeamsLeague?.id}-${t.id}`}>
                            <td>
                                {t.logo && (
                                    <Link to={`/coachs-clubhouse/team/${t.id}`}>
                                        <img
                                            src={`${TEAM_LOGO_URL}${t.logo}`}
                                            alt={`${t.name} logo`}
                                            className="teamLogo img-fluid"
                                        />
                                    </Link>
                                )}
                            </td>
                            <td>
                                <h5>
                                    <Link to={`/coachs-clubhouse/team/${t.id}`}>
                                        {t.name}
                                    </Link>
                                </h5>
                                {currentTeamsLeague?.name ||
                                    t.currentAgeLevel?.ageLevel}
                            </td>
                            <td>{t.currentAgeLevel?.ageLevel}</td>
                            <td>{t.coach.firstName}</td>
                            <td>{t.coach.lastName}</td>
                            <td>{t.coach.phone}</td>
                            <td>
                                <a href={`mailto:${t.coach.email}`}>
                                    {t.coach.email}
                                </a>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default ClubhouseTable;
